// Seeded random numbers, so a run's dungeon can be replayed from its seed.
//
// The map generator and the monster spawner both call Math.random directly.
// Rather than thread a generator through all of that code, `withSeed` swaps
// Math.random for a seeded one while the level is built, then puts it back.

// mulberry32: small, fast, good enough for level generation
function mulberry32(seed) {
    let a = seed >>> 0;
    return function random() {
        a = (a + 0x6D2B79F5) >>> 0;
        let t = Math.imul(a ^ (a >>> 15), 1 | a);
        t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
}

// FNV-1a over the seed text, so any string works as a seed
export function hashSeed(text) {
    let hash = 0x811c9dc5;
    const value = String(text);
    for (let i = 0; i < value.length; i++) {
        hash ^= value.charCodeAt(i);
        hash = Math.imul(hash, 0x01000193);
    }
    return hash >>> 0;
}

export function seededRandom(seed) {
    return mulberry32(hashSeed(seed));
}

// Run `build` with Math.random seeded; always restores the real one
export function withSeed(seed, build) {
    const real = Math.random;
    Math.random = seededRandom(seed);
    try {
        return build();
    } finally {
        Math.random = real;
    }
}

const SEED_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';

// A short, easy to read and repeat seed, e.g. "KQ7F-2M9X"
export function randomSeed() {
    let seed = '';
    for (let i = 0; i < 8; i++) {
        if (i === 4) seed += '-';
        seed += SEED_ALPHABET[Math.floor(Math.random() * SEED_ALPHABET.length)];
    }
    return seed;
}

// Tidy up what the player typed, and make sure it isn't empty
export function normaliseSeed(text) {
    const cleaned = String(text || '').trim().toUpperCase().slice(0, 24);
    return cleaned || randomSeed();
}

// Each level of a run gets its own stream, derived from the run's seed
export function levelSeed(runSeed, level) {
    return `${runSeed}:${level}`;
}

export function formatDuration(ms) {
    const total = Math.max(0, Math.round(ms / 1000));
    const minutes = Math.floor(total / 60);
    const seconds = total % 60;
    if (minutes >= 60) {
        const hours = Math.floor(minutes / 60);
        return `${hours}:${String(minutes % 60).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    }
    return `${minutes}:${String(seconds).padStart(2, '0')}`;
}
